import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import TextButton from '../TextButton';
import { breakpoints, colors } from '../../../Core/Theme';

const HeadsUpBanner = ({
  classes,
  prefix = 'Heads up:',
  message,
  actionText = '',
  onAction = () => {},
  className = '',
  storageKey = null,
  expiryDate = null,
}) => {
  const [visible, setVisible] = React.useState(() => {
    if (expiryDate && new Date() > new Date(expiryDate)) return false;
    if (storageKey && localStorage.getItem(storageKey) === 'true') return false;
    return true;
  });

  if (!visible) return null;

  const handleAction = () => {
    if (storageKey) {
      localStorage.setItem(storageKey, 'true');
    }
    setVisible(false);
    onAction();
  };

  return (
    <div role="status" className={clsx(classes.container, className)}>
      <span>
        <span className={classes.prefix}>{prefix}</span> {message}
      </span>
      {actionText && (
        <TextButton
          text={actionText}
          onClick={handleAction}
          className={classes.actionButton}
        />
      )}
    </div>
  );
};

const styles = theme => ({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#e0ecec',
    borderRadius: 24,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    padding: '12px 16px',
    fontSize: 14,
    fontFamily: 'VerlagBook',
    color: colors.palette.primary.main,
    gap: 12,
    '&::before': {
      content: '""',
      position: 'absolute',
      top: -10,
      left: '50%',
      transform: 'translateX(-50%)',
      width: 0,
      height: 0,
      borderLeft: '10px solid transparent',
      borderRight: '10px solid transparent',
      borderBottom: '10px solid #e0ecec',
    },
    [theme.breakpoints.up(breakpoints.MOBILE)]: {
      fontSize: 15,
    },
  },
  prefix: {
    fontFamily: 'VerlagBold',
  },
  actionButton: {
    fontFamily: 'VerlagBold',
    fontSize: 14,
    color: colors.palette.primary.main,
    textDecoration: 'underline',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    [theme.breakpoints.up(breakpoints.MOBILE)]: {
      fontSize: 15,
    },
  },
});

HeadsUpBanner.defaultProps = {
  prefix: 'Heads up:',
  actionText: '',
  onAction: () => {},
  className: '',
  storageKey: null,
  expiryDate: null,
};

HeadsUpBanner.propTypes = {
  classes: PropTypes.object.isRequired,
  prefix: PropTypes.string,
  message: PropTypes.node.isRequired,
  actionText: PropTypes.string,
  onAction: PropTypes.func,
  className: PropTypes.string,
  storageKey: PropTypes.string,
  expiryDate: PropTypes.string,
};

export default withStyles(styles)(HeadsUpBanner);
